import Button from "devextreme-react/button";
import { useContext, useEffect, useState } from "react";
import { LoadPagePanel } from "../../../../components";
import { MaterialOrderContext } from "../context/MaterialOrderContext";

export default function RepricingButton() {

	const { order, modifyOrder } = useContext(MaterialOrderContext);
	const [isRepricing, setIsRepricing] = useState(false);

	useEffect(() => {
		if (!order.pricingNeedsUpdate)
			setIsRepricing(false);
	}, [order.pricingNeedsUpdate]);

	return (
		<>
			<Button
				text="Repricing"
				icon="Inscyth-Pricing"
				elementAttr={{ 'data-testid': 'btn-repricing' }}
				disabled={!order.details.products || order.details.products.length === 0}
				onClick={() => {
					setIsRepricing(true);
					modifyOrder(order.details, true, true);
				}}>
			</Button>
			<LoadPagePanel visible={isRepricing}></LoadPagePanel>
		</>
	)
}
